import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Paper,
  Button,
  Grid,
  Card,
  CardContent,
  CardActions,
} from '@mui/material';
import { 
  AddCircleOutline, 
  List, 
  ArrowBack,
  Image,
  FolderSpecial,
} from '@mui/icons-material';

const TeacherDashboard = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: 'Crear Pregunta',
      description: 'Crear nueva pregunta con imágenes para los exámenes',
      icon: <AddCircleOutline sx={{ fontSize: 60 }} />,
      path: '/teacher/questions/new',
      color: '#4caf50',
    },
    {
      title: 'Ver Preguntas',
      description: 'Ver, editar y gestionar todas las preguntas creadas',
      icon: <List sx={{ fontSize: 60 }} />,
      path: '/teacher/questions',
      color: '#2196f3',
    },
    {
      title: 'Question Sets',
      description: 'Ver preguntas agrupadas por contexto compartido',
      icon: <FolderSpecial sx={{ fontSize: 60 }} />,
      path: '/teacher/question-sets',
      color: '#ff9800',
    },
    {
      title: 'Crear Examen',
      description: 'Crear examen seleccionando preguntas específicas',
      icon: <Image sx={{ fontSize: 60 }} />,
      path: '/teacher/exams/create',
      color: '#9c27b0',
    },
    {
      title: 'Mis Exámenes',
      description: 'Ver y gestionar los exámenes que has creado',
      icon: <List sx={{ fontSize: 60 }} />,
      path: '/teacher/exams',
      color: '#e91e63',
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h3" gutterBottom align="center" sx={{ fontWeight: 'bold' }}>
          Panel de Profesores
        </Typography>
        <Typography variant="h6" align="center" color="text.secondary" paragraph>
          Gestión de preguntas y exámenes
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {menuItems.map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card 
              sx={{ 
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: 6,
                },
              }}
            >
              <CardContent sx={{ flexGrow: 1, textAlign: 'center', pt: 4 }}>
                <Box sx={{ color: item.color, mb: 2 }}>
                  {item.icon}
                </Box>
                <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'bold' }}>
                  {item.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.description}
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => navigate(item.path)}
                  sx={{ 
                    backgroundColor: item.color,
                    '&:hover': {
                      backgroundColor: item.color,
                      filter: 'brightness(0.9)',
                    },
                  }}
                >
                  Ir
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Button
          variant="outlined"
          startIcon={<ArrowBack />}
          onClick={() => navigate('/dashboard')}
          size="large"
        >
          Volver al Dashboard Principal
        </Button>
      </Box>

      <Paper sx={{ p: 3, mt: 4, backgroundColor: '#e3f2fd' }}>
        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Image /> Nueva Funcionalidad: Preguntas con Imágenes
        </Typography>
        <Typography variant="body2" paragraph>
          Ahora puedes crear preguntas con imágenes alojadas en AWS S3 con CDN CloudFront para mejor rendimiento:
        </Typography>
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body2">
            Sube imágenes de contexto (gráficas, tablas, infografías)
          </Typography>
          <Typography component="li" variant="body2">
            Sube imágenes específicas para cada pregunta
          </Typography>
          <Typography component="li" variant="body2">
            Las imágenes se optimizan y cachean automáticamente
          </Typography>
          <Typography component="li" variant="body2">
            Gestiona todas tus preguntas desde un solo lugar
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default TeacherDashboard;
